<template>
  <div v-if="active && unansweredQuestions.length > 0" v-show="!loading" class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card">
      <header v-if="!loading" class="title">
        <button v-if="isFablabsContest"
                aria-label="To close modal"
                class="close cursor-pointer"
                @click="close(false)">
          <i class="fal fa-times"/>
        </button>
        <h2 qa="tell-us-title">
          {{ surveyTitle }}
        </h2>
      </header>
      <survey @close="next"
              @changeTitle="changeTitle"
              @getQuestions="getQuestions"
              :customQuestionUserType="customQuestionUserType"
              :currentUserType="currentUserType"
              :getAllQuestions="getAllQuestions"
              :isProfilePage="isProfilePage"
              :signUpForm="true"
              :unansweredQuestions="unansweredQuestions"
              :currentGrouping="currentGrouping"
              :totalCurrentUserGroups="totalCurrentUserGroups"
              :hasMore="hasMore"/>
    </aside>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import { getEnvName } from '@/mixins/util'
import i18n from '@/i18n'
import userTypes from '@/mixins/user-types'
import { demoProjectIDs } from '@/mixins/demo-data'
import mixin from './Survey/mixin'
const Survey = () =>
  import('@/components/Modals/SignupSurvey/Survey').then(({ Survey }) =>
    Survey(getEnvName()))

export default {
  components: {
    Survey
  },
  props: {
    currentUserType: {
      type: String
    },
    getAllQuestions: {
      type: Boolean
    },
    isProfilePage: {
      type: Boolean
    }
  },
  mixins: [componentState, userTypes, mixin, demoProjectIDs],
  data: function () {
    return {
      active: false,
      fablabsTitle: 'Anmeldeformular Makerspace-Challenge',
      customQuestionUserType: '',
      currentGrouping: 1,
      requiredQuestions: [],
      partnerQuestions: [],
      unansweredQuestions: this.partnerQuestions ? this.partnerQuestions : [],
      hasMore: true,
      nextGrouping: 1,
      totalGroupsViewed: 0,
      totalCurrentUserGroups: 0
    }
  },
  mounted: function () {
    this.getPartnerQuestionsByGrouping()
  },
  computed: {
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    platform: function () {
      return this.appName
    },
    isJudgingRegistration: function () {
      return this.customQuestionUserType === this.UserTypeJudge
    },
    surveyTitle: function () {
      switch (this.platform) {
        case 'neweng':
          return 'How did you hear about us?'
        case 'ysc':
          return this.isJudgingRegistration ? i18n.t('signupSurvey.yscJudgeRegistrationTitle') : i18n.t('signupSurvey.yscTitle')
        case 'ohiosci':
          return this.isJudgingRegistration ? i18n.t('signupSurvey.oasJudgeRegistrationTitle') : i18n.t('surveyMake.title')
        case 'girls-and-steam':
          return i18n.t('signupSurvey.gasTitle')
        case 'heise':
          return this.isFablabsContest ? this.fablabsTitle : i18n.t('surveyMake.title')
        default:
          return i18n.t('surveyMake.title')
      }
    },
    userInformationMissing: function () {
      return this.$store.getters.modalIsVisible('survey')
    },
    isFablabsContest: function () {
      return this.$route.name === 'fablabsthankyou' || this.$store.getters.modalData('survey')?.type === 'fablabs'
    },
    loading: function () {
      return this.$store.getters.questionLoading
    }
  },
  watch: {
    active: function (active) {
      if (active) {
        this._callback('lockScrolling', false)
      } else {
        this._callback('unlockScrolling', true)
      }
    },
    userInformationMissing: function (active) {
      this.active = active
    }
  },
  methods: {
    next: function () {
      if (this.userInformationMissing) {
        this.$store.dispatch('hideSignupSurvey')
      }
      this.hasMore = true
      this.nextGrouping = 1
      this.active = false
      this.$emit('modalDone', true, true)
    },
    showModal: function () {
      this.$nextTick(() => {
        this.active = true
        this.getQuestions()
      })
    },
    changeTitle: function () {
      this.fablabsTitle = 'Vielen Dank!'
    },
    skip: function () {
      this.close()
    },
    close: function () {
      this.active = false
    },
    getQuestions: function () {
      this.getPartnerQuestionsByGrouping()
    },
    /* Parameter meaning
      1. isProfilePage - This parameter is coming from header.vue file from profile page we have a buttons also on profile page to get the questions so that the user can edit their previous answers.
      2. currentUserType, getAllQuestions - These parameters is coming from a header.vue file from profile page. If users want to edit their previous answers, we will need to fetch all questions with answers.
      3. hasMore - This will check if questions are remaining from next group or not.
      4. nextGrouping - This is a variable to get the questions as per grouping 1, 2, 3 etc. from custom_questions table.
    */
    getPartnerQuestionsByGrouping: function () {
      this.requiredQuestions = []
      this.unansweredQuestions = []
      this.partnerQuestions = []
      if (!this.hasMore) {
        return
      }
      if (this.$isYSC || this.$isOasam || this.$isOhioScience) {
        this.filterQuestionsByType = true
      }
      this.$store.dispatch('getPartnerQuestionsByGrouping', {
        userID: this.$store.getters.currentUser.id,
        grouping: this.nextGrouping,
        filterByType: this.filterQuestionsByType,
        currentUserType: this.currentUserType,
        getAllQuestions: this.getAllQuestions
      })
        .then(response => {
          if (response.questionVisibility !== null) {
            this.totalGroupsViewed = response.questionVisibility.groupsViewed
          }
          if (response.questions.length > 0) {
            this.customQuestionUserType = response.questions[0].customQuestionUserType
          }
          if (this.totalGroupsViewed < this.nextGrouping || this.isProfilePage) {
            this.requiredQuestions = response.questions
          } else {
            this.requiredQuestions = response.questions.filter(q => q.required)
          }
          if (this.requiredQuestions.length > 0) {
            this.totalCurrentUserGroups = response.totalGroups
            this.partnerQuestions.push.apply(this.partnerQuestions, response.questions)
            this.hasMore = response.hasMore
            this.currentGrouping = this.partnerQuestions[this.partnerQuestions.length - 1].grouping
            this.nextGrouping += 1
            this.active = true
            this.unansweredQuestions = this.partnerQuestions
            if (this.isProfilePage) {
              this.$emit('doneQuestionLoading')
            }
          } else if (response.hasMore) {
            this.nextGrouping += 1
            this.getPartnerQuestionsByGrouping()
          } else if (!this.isProfilePage) { // only skip when not on the profile page
            console.log('No signup questions find - skipping modal')
            this.close()
          }
        }, (err) => {
          this.errorMessage = err
        }).finally(() => {
          if (this.isOnDemoProject()) {
            this.close()
          }
        })
    },
    isOnDemoProject: function () {
      if (demoProjectIDs.includes(this.$store.getters.currentProjectID)) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

  $border-color: #DCDCDC;
  $modal-body-color: #F2F2F2;
  $error-message-height: 24px;
  $close-icon-color: #1A051D;

  .modal-card {
    background: $modal-body-color;
    text-align: center;

    // HEADER
    .title {
      border-bottom: 1px solid $border-color;
      padding: 1.3rem 0;
      h2 {
        font-family: $primary-font;
        font-weight: $primary-font-weight;
        font-size: 1.5rem;
      }
    }
  }

  .close {
    top: 0.4rem;
    right: 1rem;
    position: absolute;
    font-size: 1.5rem;
    color:  $close-icon-color;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
       color: $link-hover;
     }
  }

</style>
